module.exports = __webpack_public_path__ + "static/Product-Summary-Colorlight-X16-cf4060dbed9d83bb0502d7169d07108f.jpg";